import { Currency, ETHER, ChainId } from '@uniswap/sdk'

/** 按当前链返回原生币展示符号（K 链为 K，BSC 为 BNB） */
export function getNativeCurrencySymbol(chainId?: ChainId | null): string {
  if (chainId === ChainId.BSC) return 'BNB'
  return process.env.REACT_APP_NATIVE_CURRENCY_SYMBOL ?? 'K'
}

/** 获取货币展示符号；原生币会按 chainId 映射，避免 SDK 中 ETHER.symbol 固定为 K */
export function getCurrencySymbol(currency?: Currency | null, chainId?: ChainId | null): string {
  if (!currency) return ''
  if (currency === ETHER) return getNativeCurrencySymbol(chainId)
  return currency.symbol || ''
}
